import { cn } from "../../../utils/cn.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Surface/Surface.tsx
function SurfaceRoot({ className, children, ...props }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("@container/surface min-w-0 overflow-hidden rounded-lg border border-(length:--border-width-default) border-border-primary bg-elevation-surface-primary", className),
		...props,
		children
	});
}
SurfaceRoot.displayName = "Surface";
function SurfaceHeader({ className, children, title = null, ...props }) {
	return /* @__PURE__ */ jsxs("header", {
		className: cn("flex h-[40px] shrink-0 min-w-0 items-center gap-sm border-b-(length:--border-width-default) border-border-primary bg-elevation-surface-primary px-lg py-xs", className),
		...props,
		children: [title != null && /* @__PURE__ */ jsx("span", {
			className: "shrink-0 font-heading-medium text-body-base text-text-primary",
			children: title
		}), children]
	});
}
SurfaceHeader.displayName = "Surface.Header";
function SurfaceBody({ className, children, ...props }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("flex min-h-0 min-w-0", className),
		...props,
		children
	});
}
SurfaceBody.displayName = "Surface.Body";
function SurfaceSidePanel({ className, children, border = "right", ...props }) {
	return /* @__PURE__ */ jsx("aside", {
		className: cn("shrink-0 bg-elevation-surface-primary", border !== "none" && "border-border-primary", border === "right" && "border-r-(length:--border-width-default)", border === "left" && "border-l-(length:--border-width-default)", className),
		...props,
		children
	});
}
SurfaceSidePanel.displayName = "Surface.SidePanel";
function SurfaceContent({ className, children, ...props }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("min-w-0 flex-1 overflow-x-hidden", className),
		...props,
		children
	});
}
SurfaceContent.displayName = "Surface.Content";
/**
* Fixed-height toolbar for use inside `Surface.Content` or `Surface.SidePanel`.
*
* Unlike `Surface.Header` (which spans the full surface width above the body),
* `ContentHeader` lives *within* a body section and provides a consistent
* bar for section titles, counts, filter buttons, and actions. The height is
* locked so content like warning icons or badges never cause the bar to grow.
*
* @param props - Standard HTML header attributes plus an optional `title`
*/
function SurfaceContentHeader({ className, children, title = null, ...props }) {
	return /* @__PURE__ */ jsxs("header", {
		className: cn("flex h-[40px] shrink-0 items-center gap-xs border-b-(length:--border-width-default) border-border-primary px-sm", className),
		...props,
		children: [title != null && /* @__PURE__ */ jsx("span", {
			className: "shrink-0 truncate text-body-small leading-body-small font-heading-semi-bold text-text-primary",
			children: title
		}), children]
	});
}
SurfaceContentHeader.displayName = "Surface.ContentHeader";
const Surface = Object.assign(SurfaceRoot, {
	Header: SurfaceHeader,
	Body: SurfaceBody,
	SidePanel: SurfaceSidePanel,
	Content: SurfaceContent,
	ContentHeader: SurfaceContentHeader
});
//#endregion
export { Surface };

//# sourceMappingURL=Surface.js.map